//* Import libraries
import { useState, useCallback, useEffect } from "react";

//* Import react-router hooks
import { Link, useNavigate } from "react-router-dom";

//* Import components
import { List } from "../../../component/list/list";
import { Loading } from "../../../component/common/Loading";

//* Import custom hooks
import { useDemands } from "../../../hooks/demand/useDemands";

import { Demands } from "../../../hooks/demand/types/types";
import { Button, Form, Spinner, Row, Col } from "react-bootstrap";
import { Attention } from "../../../component/base/Attention";
import ModalMensagem from "../../../component/base/ModalMensagem";

var debounce = require("lodash.debounce");

export function Legibilidade() { 
  const token = localStorage.getItem("token") || "";

  const [answers, setAnswers]: any = useState({});

  const onchangeInput=(e:any,key:any)=>{
    if(e.target.value!='' && Number.isNaN(e.target.value)){
      return;
    }

    let answers_ = { ...answers }
    answers_[key] =e.target.value==''?'': parseInt(e.target.value)
    setAnswers(answers_)
  }



  return (
    <div className="row">
      <div className="col-12">

        <div className={"py-5 px-3"}>
          <div className={"card-body"} id="card">
            <h4
              className="mt-0 header-title"
              style={{ fontSize: "2.0rem", color: "black" }}
            >
              Legibilidade
            </h4>
            <br></br>
            <br></br>
            <h4
              className="mt-0 header-title"
              style={{ fontSize: "1.5rem", color: "black" }}
            >
              Explicação do critério:
            </h4>
            <br></br>
            <p align="justify"> <strong> Critério que avalia o quão fácil é para os desenvolvedores entenderem o código-fonte, a arquitetura do sistema e as comunicações realizadas 
              pelo software durante a sua execução. Isso afeta diretamente a capacidade de modificar e corrigir o software. </strong> </p>
              <p align="justify"> <strong> Qual é o seu peso na avaliação desse critério? Digite no campo abaixo </strong> </p>
            <Form.Control
                    placeholder=""
                    style={{  }}
                    value={answers['inicial'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'inicial')
                    }}
                    required
                    
                  />
            <br></br>

            <h4
              className="mt-0 header-title"
              style={{ fontSize: "1.5rem", color: "black" }}
            >
              Avaliação dos critérios:
            </h4>
            <br></br>


            <Form.Group className="mb-3">
              <Form.Label style={{ fontSize: 18 }} align="justify">
              Simplificação de leitura: A equipe de desenvolvimento deve utilizar recursos que facilitem o entendimento do código-fonte do software. Por exemplo, deve-se padronizar 
              a utilização de nomes de variáveis. Como essa boa prática é atendida? <Attention />
              </Form.Label>
              <div>
                 <Form.Check
                                type="radio"
                                label="Atendimento total"
                                name="questao1"
                                checked={answers[1] === 1}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[1] = 1;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento parcial"
                                name="questao1"
                                checked={answers[1] === 2}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[1] = 2;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento inexistente"
                                name="questao1"
                                checked={answers[1] === 3}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[1] = 3;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Não sabe responder"
                                name="questao1"
                                checked={answers[1] === 4}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[1] = 4;
                                  setAnswers(answers_)
                                }}
                              />
              </div>
            </Form.Group>


            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{ fontSize: 18 }} align="justify">
              Mensagens de erros: O software deve ser implementado de forma que gere mensagens de erro claras e que indiquem o que resultou no erro do usuário. 
              Como essa boa prática é atendida?  <Attention />
              </Form.Label>
              <div>
              <Form.Check
                                type="radio"
                                label="Atendimento total"
                                name="questao2"
                                checked={answers[2] === 1}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[2] = 1;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento parcial"
                                name="questao2"
                                checked={answers[2] === 2}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[2] = 2;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento inexistente"
                                name="questao2"
                                checked={answers[2] === 3}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[2] = 3;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Não sabe responder"
                                name="questao2"
                                checked={answers[2] === 4}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[2] = 4;
                                  setAnswers(answers_)
                                }}
                              />

                
              </div>
            </Form.Group>
            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{ fontSize: 18 }} align="justify">
              Feedback de desenvolvimento: A equipe de desenvolvimento deve colher feedbacks entre a equipe de forma a entender a facilidade com que a implementação está ocorrendo. 
              Como essa boa prática é atendida?  <Attention />
              </Form.Label>
              <div>
              <Form.Check
                                type="radio"
                                label="Atendimento total"
                                name="questao3"
                                checked={answers[3] === 1}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[3] = 1;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento parcial"
                                name="questao3"
                                checked={answers[3] === 2}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[3] = 2;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento inexistente"
                                name="questao3"
                                checked={answers[3] === 3}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[3] = 3;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Não sabe responder"
                                name="questao3"
                                checked={answers[3] === 4}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[3] = 4;
                                  setAnswers(answers_)
                                }}
                              />
              </div>
            </Form.Group>
            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{ fontSize: 18 }} align="justify">
              Satisfação dos Stakeholders: A equipe de desenvolvimento deve sempre avaliar se as necessidades e as expectativas dos Stakeholders estão sendo atendidas rapidamente 
              e sem dificuldades. Como essa boa prática é atendida? <Attention />
              </Form.Label>
              <div>
              <Form.Check
                                type="radio"
                                label="Atendimento total"
                                name="questao4"
                                checked={answers[4] === 1}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[4] = 1;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento parcial"
                                name="questao4"
                                checked={answers[4] === 2}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[4] = 2;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento inexistente"
                                name="questao4"
                                checked={answers[4] === 3}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[4] = 3;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Não sabe responder"
                                name="questao4"
                                checked={answers[4] === 4}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[4] = 4;
                                  setAnswers(answers_)
                                }}
                              />
                </div>
            </Form.Group>
            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{ fontSize: 18 }} align="justify">
              Arquitetura de software simples: A arquitetura do software deve ser sempre a mais simples possível e discutida com todos os desenvolvedores, de forma que todos 
              saibam o que está ocorrendo. Como essa boa prática é atendida?  <Attention />
              </Form.Label>
              <div>
                
              <Form.Check
                                type="radio"
                                label="Atendimento total"
                                name="questao5"
                                checked={answers[5] === 1}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[5] = 1;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento parcial"
                                name="questao5"
                                checked={answers[5] === 2}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[5] = 2;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento inexistente"
                                name="questao5"
                                checked={answers[5] === 3}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[5] = 3;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Não sabe responder"
                                name="questao5"
                                checked={answers[5] === 4}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[5] = 4;
                                  setAnswers(answers_)
                                }}
                              />
              </div>
            </Form.Group>
            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{ fontSize: 18 }} align="justify">
              Consistência de ambiente e bibliotecas: Software científico tem a tendência de utilizar bibliotecas e ferramentas de terceiros, que podem ter atualizações frequentes 
              ou até ficar obsoletas. Assim, é importante garantir a consistência do ambiente para manter o software disponível e funcional. Como essa boa prática é atendida?  <Attention />
              </Form.Label>
              <div>
                
              <Form.Check
                                type="radio"
                                label="Atendimento total"
                                name="questao6"
                                checked={answers[6] === 1}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[6] = 1;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento parcial"
                                name="questao6"
                                checked={answers[6] === 2}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[6] = 2;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento inexistente"
                                name="questao6"
                                checked={answers[6] === 3}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[6] = 3;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Não sabe responder"
                                name="questao6"
                                checked={answers[6] === 4}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[6] = 4;
                                  setAnswers(answers_)
                                }}
                              />
              </div>
            </Form.Group>
            
            
            <br></br>

            <button onClick={(e) => {

            }} className="btn btn-success btn-lg w-100">
              Gerar resultado
            </button>
            <ModalMensagem/>














          </div>
        </div>
      </div>

    </div>
  );
}
